<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 210px'>
        <p>供应商：</p>
        <el-input v-model='teamNameIpt' size='mini' style='width:150px' placeholder='请输入供应商名称' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>登录手机号：</p>
        <el-input v-model='accountIpt' size='mini' style='width:150px' placeholder='请输入登录手机号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>服务区域：</p>
        <el-cascader v-model='serviceArea' filterable :options='regionList' style='width:150px'
                     :props="{
                        expandTrigger: 'hover',
                        value: 'id',
                        label: 'cityName',
                        children: 'children',
                        multiple: false,
                      }" size='mini' collapse-tags clearable placeholder='请选择所在区域'
                     ref='areaCascader' />
      </div>
      <div class='navContainer'>
        <p>状态：</p>
        <el-select v-model='stateIpt' filterable size='mini' style='width:150px' placeholder='请选择'>
          <el-option v-for='item in stateOption' :key='item.value' :label='item.name'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :row-class-name='tableRowClassName'
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='name' label='供应商全称' align='center' show-overflow-tooltip />
          <!-- <el-table-column prop="shortName" label="供应商简称" align="center"/> -->
          <el-table-column prop='account' label='登录账号' align='center' width='140'
                           show-overflow-tooltip />
          <el-table-column prop='serviceRegionName' label='服务区域' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='address' label='详细地址' align='center' show-overflow-tooltip />
          <el-table-column prop='carNum' label='运输车数量' align='center' width='80'
                           show-overflow-tooltip />
          <el-table-column prop='driverNum' label='司机数量' align='center' width='80'
                           show-overflow-tooltip />
          <el-table-column prop='statusStr' label='状态' align='center' width='80'>
            <div slot-scope='scope'>{{ setState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label='操作' align='center' min-width='200'>
            <template slot-scope='scope'>
              <el-button size='mini' class='searchBtn operate-button' type='primary'
                         @click='detailClick(scope.row.id)'>详情
              </el-button>
              <!-- <el-button v-if="scope.row.examine===1" size="mini" type="primary" @click="changeClick2(scope.row.id)" class="yellow-bg">修改基础信息</el-button>
              <el-button v-if="scope.row.examine===7"  size="mini" type="primary" @click="changeClick(scope.$index, scope.row)" class="yellow-bg">信息变更</el-button>
              <el-button v-if="scope.row.examine===1" size="mini" type="danger" @click="disableClick(scope.$index, scope.row)">终止合作</el-button> -->
              <el-button v-if='scope.row.status===0' size='mini' type='primary'
                         @click='editBtn(scope.row.id,1)' class='yellow-bg operate-button'>修改
              </el-button>
              <el-button v-if='scope.row.status===1 && scope.row.examine !=0' size='mini'
                         type='primary' @click='editBtn(scope.row.id,2)'
                         class='yellow-bg operate-button'>信息变更
              </el-button>
              <el-button v-if='scope.row.status===0' size='mini' type='info' style='margin-left:5px'
                         @click='enableClick(scope.row.id)'>取消审核
              </el-button>
              <el-button v-if='scope.row.status==0||scope.row.status==3' size='mini' type='danger'
                         @click='deleteClick(scope.row.id)' class='operate-button'>删除
              </el-button>
              <el-button v-if='scope.row.status===1  && scope.row.examine !=0' size='mini'
                         type='danger' @click='disableClick(scope.$index, scope.row.id)'
                         class='operate-button'>终止合作
              </el-button>
              <!-- <el-button v-if="scope.row.status===0" size="mini" type="info" @click="enableClick(scope.$index, scope.row.id)" class="operate-button">取消审核</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='650px' center top='10vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ getState(detailData.status) }}</p>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>供应商名称：</span>
              <span>{{ detailData.name }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>服务区域：</span>
              <span>{{ detailData.serviceRegionName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>详细地址：</span>
              <span>{{ detailData.address }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>邮箱：</span>
                <span>{{ detailData.mailBox }}</span>
              </div>
              <div>
                <span class='span1'>电话：</span>
                <span>{{ detailData.phone }}</span>
              </div>
            </div>
            <div v-for='(item,index) in detailData.person' :key='index'>
              <div class='baseInfoContentItem specialItem'>
                <div class='specialOne'>
                  <span class='span1'>对接人姓名：</span>
                  <span>{{ item.name }}</span>
                </div>
                <div>
                  <span class='span1'>对接人电话：</span>
                  <span>{{ item.tell }}</span>
                </div>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>对接人职位：</span>
                <span>{{ item.position }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>物流属性：</span>
              <span>{{ detailData.logisticsAttribute!=null?(detailData.logisticsAttribute==0?'民生':'非民生'):''}}</span>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>附件信息</span>
          </div>
          <div class='attachment'>
            <div v-for='(item,index) in detailData.attachData' class='attachmentItem' :key='index'>
              <span style='text-decoration: underline;cursor: pointer;'>{{ item.name }}</span>
              <span>{{ item.time }}</span>
              <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item)'
                 v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                        ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                        ||item.name.substring(item.name.indexOf('.')) == '.JPG'
                         ||item.name.substring(item.name.indexOf('.')) == '.png'
                         || item.name.substring(item.name.indexOf('.')) == '.gif'">

              </i>
              <i class='el-icon-download' @click='downloadClick(item.id)'></i>
            </div>
          </div>
        </div>
        <!-- <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>审核信息</span>
          </div>
          <steps :step-data="stepData" :step-state="stepState"/>
        </div> -->
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>操作信息</span>
          </div>
          <div class='operationTable'>
            <el-table :data='operationData' border>
              <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
              <el-table-column prop='operateType' label='操作类型' align='center' />
              <el-table-column prop='operationName' label='操作人' align='center' />
              <el-table-column prop='remark' label='备注' align='center' />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <transition name='el-fade-in-linear'>
      <popup :title='dialogTitle' class='add-edit' :show.sync='dialogVisible' width='600' center
             @close='dialogClose' :close-on-click-modal='false' top='10vh'>
        <div class='company'>
          <el-form :model='teamData' label-width='100px' :rules='rules' ref='ruleForm'>
            <div-border label='基础信息'>
              <el-row>
                <el-col v-if="edit == 'add'">
                  <el-form-item label='登录账号：' prop='account' style='margin-top: 15px'>
                    <el-input style='width:100%' v-model='teamData.account' placeholder='请输入登录账号'
                              autocomplete='off' size='small' />
                  </el-form-item>
                </el-col>
                <el-col v-if="edit == 'add'">
                  <el-form-item label='登录密码：' prop='password'>
                    <el-input style='width:100%' v-model='teamData.password' placeholder='请输入登录密码'
                              autocomplete='off' size='small' show-password />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label='供应商全称：' prop='teamName'
                                :style="{marginTop:(dialogTitle=='修改公路供应商'?'15px':'0px')}">
                    <el-input
                      :style="'width:100%'"
                      v-model='teamData.teamName'
                      placeholder='请输入供应商全称'
                      autocomplete='off'
                      size='mini'
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label='供应商简称：' prop='referred'>
                    <el-input
                      :style="'width:100%'"
                      v-model='teamData.referred'
                      placeholder='请输入供应商简称'
                      autocomplete='off'
                      size='mini'
                    />
                  </el-form-item>
                </el-col>
                <!-- <el-col v-if="dialogTitle==='新增公路供应商' || dialogTitle==='修改公路供应商'">
                  <el-form-item label="关键词：" prop="keyword">
                    <el-input
                      :style="'width:100%'"
                      v-model="teamData.keyword"
                      placeholder="请输入关键词"
                      autocomplete="off"
                      size="mini"
                    />
                  </el-form-item>
                </el-col> -->
                <!-- <el-col>
                  <el-form-item label="登录手机号：" prop="account">
                    <el-input
                      :style="'width:100%'"
                      v-model="teamData.account"
                      placeholder="请输入登录手机号"
                      autocomplete="off"
                      size="mini"
                    />
                  </el-form-item>
                </el-col> -->
                <el-col>
                  <el-form-item label='服务区域：' prop='area'>
                    <el-cascader
                      size='mini'
                      ref='checkServe'
                      v-model='teamData.area'
                      class='specialSelect'
                      :options='regionList'
                      collapse-tags
                      :props="{
                        expandTrigger: 'hover',
                        value: 'id',
                        label: 'cityName',
                        children: 'children',
                        multiple: true,
                      }"
                      style='width:100%'
                      clearable
                      filterable
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label='详细地址：' prop='address'>
                    <!-- <div style="display: flex;cursor: pointer;align-items: center;" @click="mapVisible=true"> -->
                    <div style='display: flex;cursor: pointer;align-items: center;'>
                      <el-input
                        style='width:100%;'
                        v-model='teamData.address'
                        placeholder='点击选择分公司详细地址'
                        autocomplete='off'
                        size='small'
                      />
                      <!-- <i class="el-icon-location"/> -->
                    </div>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label='物流属性：'>
                    <el-radio-group v-model='teamData.logisticsAttribute'>
                      <el-radio :label='0'>民生</el-radio>
                      <el-radio :label='1'>非民生</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span='12' v-if="dialogTitle==='新增公路供应商' || dialogTitle==='修改公路供应商'">
                  <el-form-item label='邮箱：' prop='mail'>
                    <el-input
                      :style="'width:100%'"
                      v-model='teamData.mail'
                      placeholder='请输入邮箱'
                      autocomplete='off'
                      size='mini'
                    />
                  </el-form-item>
                </el-col>
                <el-col :span='12' v-if="dialogTitle==='新增公路供应商' || dialogTitle==='修改公路供应商'">
                  <el-form-item label='电话：'>
                    <el-input
                      :style="'width:100%'"
                      v-model='teamData.carTell'
                      placeholder='请输入电话'
                      autocomplete='off'
                      size='mini'
                    />
                  </el-form-item>
                </el-col>
                <div v-for='(item,index) in teamData.person' :key='index'>
                  <el-col :span='12'>
                    <el-form-item label='对接人姓名：' :prop='`person.${index}.name`' :rules='rules.name'>
                      <el-input
                        :style="'width:100%'"
                        v-model='item.name'
                        placeholder='请输入对接人姓名'
                        autocomplete='off'
                        size='mini'
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item label='对接人电话：' :prop='`person.${index}.tell`' :rules='rules.tell'>
                      <el-input
                        :style="'width:100%'"
                        v-model='item.tell'
                        placeholder='请输入对接人电话'
                        autocomplete='off'
                        size='mini'
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label='对接人职位：' :prop='`person.${index}.position`'
                                  :rules='rules.position'>
                      <div style='display:flex;align-items:center;'>
                        <el-input
                          :style="'width:179px'"
                          v-model='item.position'
                          placeholder='请输入对接人职位'
                          autocomplete='off'
                          size='mini'
                        />
                        <div style='display:flex;align-items:center;margin-left: 25px;'
                             v-if='index===teamData.person.length-1'>
                          <el-button
                            style='margin-left: 10px;height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;'
                            size='mini'
                            type='info'
                            icon='el-icon-plus'
                            circle
                            @click='levelAdd'
                          />
                          <el-button
                            v-if='teamData.person.length!==1'
                            style='height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;'
                            size='mini'
                            type='info'
                            icon='el-icon-minus'
                            circle
                            @click='levelMinus'
                          />
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </div>
                <el-col>
                  <el-form-item :label="(edit == 'add')?'新增原因：':((edit == 'edit')?'新增原因：':'变更原因：')"
                                prop='mark' style='margin-top: 10px;margin-bottom: 20px;'>
                    <el-input
                      type='textarea'
                      :style="'width:90%'"
                      v-model='teamData.mark'
                      placeholder='请输入原因'
                      autocomplete='off'
                      size='mini'
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div-border>
            <div-border label='上传附件' :isNeed='true'>
              <el-form-item style='margin-top:15px; ' label-width='50px'>
                <div class='imgUp'>
                  <el-upload
                    ref='upload'
                    class='upload-demo'
                    :action='uploadUrl'
                    :before-upload='beforeAvatarUpload'
                    :show-file-list='false'
                    :data='uploadData'
                    :on-change='uploadChange'
                    :on-progress='progress'
                    :on-success='success'
                    :file-list='teamData.enclosure'
                    :limit='5'
                  >
                    <!-- <i class="el-icon-plus"/> -->
                    <el-button size='small' :loading='imgIsUpload' type='primary'>点击上传</el-button>
                    <div slot='tip' style='margin-top: 6px;margin-left: 10px'>支持扩展名：.rar .zip .doc
                      .docx .pdf .jpg...
                    </div>
                  </el-upload>
                  <div v-for='(item,index) in teamData.enclosure' :key='index'>
                    <div class='upload'>{{ item.name }}
                      <div>
                        <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item,index)'
                           v-if="item.name.substring(item.name.indexOf('.')) === '.jpeg'
                                 ||item.name.substring(item.name.indexOf('.')) === '.png'
                                 ||item.name.substring(item.name.indexOf('.')) === '.jpg'
                                 ||item.name.substring(item.name.indexOf('.')) === '.JPG'
                                 || item.name.substring(item.name.indexOf('.')) === '.gif'"></i>
                        <i class='el-icon-upload2' @click='uploadClick(item,index)'></i>
                        <i class='el-icon-delete' @click='handleRemove(item,index)'></i></div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div-border>
            <div class='btnContainer'>
              <el-button v-if="edit == 'edit'" size='medium' class='searchBtn'
                         :loading='imgIsUpload' @click='addClick(2)'>修改
              </el-button>
              <el-button v-else-if="edit == 'add'" size='medium' class='searchBtn'
                         :loading='imgIsUpload' @click='addClick(1)'>添加
              </el-button>
              <el-button v-else class='searchBtn' size='medium' :loading='imgIsUpload'
                         @click='addClick(3)'>变更
              </el-button>
              <el-button class='resetBtn' size='medium' @click='dialogClose'>关闭</el-button>
            </div>
          </el-form>
        </div>
      </popup>
    </transition>
    <el-dialog title='终止合作' :visible.sync='termination' width='500px' center
               :close-on-click-modal='false'>
      <div class='cooperation'>
        <p><span style='color:red'>*</span>终止合作原因：</p>
        <el-input
          type='textarea'
          style='width:400px;margin-left: 30px;margin-bottom: 20px;'
          v-model='remark'
          placeholder='请输入终止合作原因'
          autocomplete='off'
          size='mini'
        />
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' @click='terminationClick'>确认</el-button>
          <el-button size='medium' class='resetBtn' @click='termination=false'>取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title='修改基础信息' :visible.sync='baseInfoVisible' width='600px' center
               :close-on-click-modal='false'>
      <div class='detail'>
        <div-border label='基础信息' is-need='true' divStyle='margin-top: 10px'>
          <div class='baseInfo'>
            <div class='baseInfoContent'>
              <div class='baseInfoContentItem'>
                <span class='span1'>供应商名称：</span>
                <span>{{ detailData.teamName }}</span>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>登录手机号：</span>
                <span>{{ detailData.account }}</span>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>服务区域：</span>
                <span>{{ detailData.area }}</span>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>详细地址：</span>
                <span>{{ detailData.address }}</span>
              </div>
              <div v-for='(item,index) in detailData.person' :key='index'>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne'>
                    <span class='span1'>对接人姓名：</span>
                    <span>{{ item.name }}</span>
                  </div>
                  <div>
                    <span class='span1'>对接人电话：</span>
                    <span>{{ item.tell }}</span>
                  </div>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>对接人职位：</span>
                  <span>{{ item.position }}</span>
                </div>
              </div>
            </div>
          </div>
        </div-border>
        <div-border label='基础信息' is-need='true' divStyle='margin-top: 10px'>
          <div class='baseInfoContainer'>
            <el-row>
              <el-col>
                <span><span style='color:red'>*</span>关键词：</span>
                <el-input
                  style='width:81%;margin-bottom: 15px'
                  v-model='baseInfo.keyword'
                  placeholder='请输入关键词'
                  autocomplete='off'
                  size='mini'
                />
              </el-col>
              <el-col :span='12'>
                <span style='margin-left: 20px;'>邮箱：</span>
                <el-input
                  style='width:70%;'
                  v-model='baseInfo.mail'
                  placeholder='请输入邮箱'
                  autocomplete='off'
                  size='mini'
                />
              </el-col>
              <el-col :span='12'>
                <span>电话：</span>
                <el-input
                  style='width:70%;'
                  v-model='baseInfo.tell'
                  placeholder='请输入电话'
                  autocomplete='off'
                  size='mini'
                />
              </el-col>
            </el-row>
          </div>
        </div-border>
        <div class='btnContainer'>
          <el-button class='searchBtn' size='medium' @click='basicInfoConfirmClick'>确认</el-button>
          <el-button class='resetBtn' size='medium' @click='basicInfoClose'>取消</el-button>
        </div>
      </div>
    </el-dialog>
    <transition name='el-fade-in-linear'>
      <popup width='850' title='详细地址' :show.sync='mapVisible' center>
        <web-map :useType="'select'" @close='mapClose' v-if='mapVisible'
                 :address='teamData.address' />
      </popup>
    </transition>
    <el-dialog title='图片' center :visible.sync='imgDialogVisible' width='200px;' append-to-body>
      <img style='width:100%;object-fit:cover' :src='dialogImageUrl' alt=''>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import steps from '@/components/steps';
  import { getSessionStore, removeSpace } from '@/config/mUtils';
  import {
    addHighwaySupplier,
    editHighwaySupplier,
    changeHighwaySupplier,
    highwaySupplierBasicInfoUpdate,
    highwaySupplierDetail,
    highwaySupplierList,
    highwaySupplierDisable,
    highwaySupplierEnable,
    highwaySupplierDelete,
    highwaySupplierStatusSelectList,
  } from '@/service/basicfile';
  import webMap from '@/components/map';
  import popup from '@/components/popup';
  import { baseImgUrl, baseUrl } from '@/config/env';

  export default {
    components: {
      divBorder,
      steps,
      webMap,
      popup,
    },
    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入登录账号'));
        } else if (value.length < 3 || value.length > 16) {
          callback(new Error('请输入正确的登录账号'));
          // } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          //   callback(new Error('请输入正确的登录手机号'));
        } else {
          callback();
        }
      };
      const validateTell2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入对接人电话'));
        } else if (
          !(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)
          &&
          !(/0\d{2,3}(-)?\d{7,8}/).test(value)
        ) {
          callback(new Error('请输入正确的对接人电话'));
        } else {
          callback();
        }
      };
      return {
        dialogImageUrl: '',
        imgDialogVisible: false,
        mapVisible: false,
        teamNameIpt: '',
        accountIpt: '',
        serviceArea: '',
        stateIpt: '',
        regionList: [],
        stateOption: [
          {
            value: '',
            name: '全部',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        detailData: {
          person: [],
          attachData: [],
        },
        operationData: [],
        dialogTitle: '',
        dialogVisible: false,
        teamData: {
          teamName: '',
          keyword: '',
          account: '',
          area: '',
          address: '',
          carTell: '',
          mail: '',
          name: '',
          tell: '',
          remark: '',
          referred: '',
          logisticsAttribute: 0,
          person: [
            {
              name: '',
              tell: '',
              position: '',
            },
          ],
          enclosure: [],//附件
        },
        uploadData: {
          fileType: 0,
        },
        uploadUrl: '',
        uploadFlag: false,//替换
        uploadIndex: '',//替换索引
        areaOption: [],
        rules: {
          teamName: [
            {
              required: true,
              message: '请输入供应商全称',
              trigger: 'blur',
            },
          ],
          referred: [
            {
              required: true,
              message: '请输入供应商简称',
              trigger: 'blur',
            },
          ],
          keyword: [
            {
              required: true,
              message: '请输入关键词',
              trigger: 'blur',
            },
          ],
          account: [
            {
              required: true,
              validator: validateTell,
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              message: '请输入密码',
              trigger: 'blur',
            },
          ],
          area: [
            {
              required: true,
              message: '请输入服务区域',
              trigger: 'change',
            },
          ],
          address: [
            {
              required: true,
              message: '请输入车队详细地址',
              trigger: 'blur',
            },
          ],
          carTell: [
            {
              required: true,
              message: '请输入车队电话',
              trigger: 'blur',
            },
          ],
          name: [
            {
              required: true,
              message: '请输入对接人姓名',
              trigger: 'blur',
            },
          ],
          tell: [
            {
              required: true,
              validator: validateTell2,
              trigger: 'blur',
            },
          ],
          position: [
            {
              required: true,
              message: '请输入对接人职位',
              trigger: 'blur',
            },
          ],
          mark: [
            {
              required: true,
              message: '请输入原因',
              trigger: 'blur',
            },
          ],
        },
        termination: false,
        remark: '',
        baseInfoVisible: false,
        baseInfo: {
          keyword: '',
          mail: '',
          tell: '',
        },
        imgIsUpload: false,
        baseImgUrl: baseImgUrl + '/',
        map: new Map(),

        // 修改弹窗控制变量
        edit: false,
        // 终止合作id
        disableId: '',
        // 取消审核id
        enableId: '',
      };
    },
    computed: {
      getState() {
        return function(state) {
          // switch(state) {
          //   case 0:
          //     return '待审核'
          //   case 1:
          //     return '合作中'
          //   case 2:
          //     return '终止合作'
          //   case 3:
          //     return '已完成'
          //   case 4:
          //     return '已取消'
          // }
          for (let i = 0; i < this.stateOption.length; i++) {
            if (state === this.stateOption[i].value) return this.stateOption[i].name;
          }
        };
      },
      // 设置状态值
      setState() {
        return function(state) {
          switch (state) {
            case 0:
              return '待审核';
            case 1:
              return '合作中';
            case 2:
              return '终止合作';
            case 3:
              return '已取消';
          }
          for (let i = 0; i < this.stateOption.length; i++) {
            if (state === this.stateOption[i].value) return this.stateOption[i].name;
          }
        };
      },
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
    },
    async mounted() {
      this._highwaySupplierList();
      this.regionList = JSON.parse(getSessionStore('areaList'));
      this.areaOption = this.regionList;
      if (this.areaOption.length > 0) {
        this.areaOption.pop();
      }
      await this._highwaySupplierList();
      // const res = await highwaySupplierStatusSelectList();
      // if(res.status !== 0) this.$message.error(res.message);
      // else this.stateOption=[...this.stateOption,...res.data]
      this.stateOption = [{
        value: '',
        name: '全部',
      }, {
        value: '0',
        name: '待审核',
      }, {
        value: '1',
        name: '合作中',
      },
        {
          value: '2',
          name: '终止合作',
        }, {
          value: '3',
          name: '已取消',
        }];
      this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
      for (let i = 0; i < this.areaOption.length; i++) {
        for (let j = 0; j < this.areaOption[i].children.length; j++) {
          if (this.areaOption[i].children[j].children) {
            for (let s = 0; s < this.areaOption[i].children[j].children.length; s++) {
              // console.log(this.areaOption[i].children[j]);
              // this.map.set(this.areaOption[i].children[j].children[s].id, this.areaOption[i].children[j].children[s].mergerName);
              this.map.set(this.areaOption[i].children[j].children[s].id, this.areaOption[i].children[j].children[s].cityName);
            }
          }
        }
      }
    },
    methods: {
      async _highwaySupplierList() {
        let str = '';
        if (this.serviceArea) {
          this.serviceArea.forEach((item, index) => {
            if (index !== this.serviceArea.length - 1) {
              str += item + ',';
            } else {
              str += item;
            }
          });
        }
        this.tableLoad = true;
        const res = await highwaySupplierList(
          {
            name: this.teamNameIpt,
            account: this.accountIpt,
            serviceRegionId: str,
            status: this.stateIpt,
            rows: this.size,
            page: this.page,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      mapClose(val, lnglat, area, adcode) {
        console.log(val, 'val');
        console.log(lnglat, 'lnglat');
        console.log(area, 'area');
        console.log(adcode, 'adcode');
        this.teamData.address = val;
        this.teamData.area2 = area;
        this.teamData.adcode = adcode;
        this.teamData.longitude = lnglat[0];
        this.teamData.latitude = lnglat[1];
        this.mapVisible = false;
      },
      basicInfoClose() {
        this.baseInfoVisible = false;
      },
      async basicInfoConfirmClick() {
        this.baseInfo.keyword = this.baseInfo.keyword.trim();
        if (this.baseInfo.keyword === '') return this.$message.warning('关键词不能为空！');
        const res = await highwaySupplierBasicInfoUpdate(
          {
            id: this.baseInfo.id,
            keyword: this.baseInfo.keyword,
            phone: this.baseInfo.tell,
            mailBox: this.baseInfo.mail,
          },
        );
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.baseInfoVisible = false;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._highwaySupplierList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._highwaySupplierList();
      },
      // 终止合作
      disableClick(index, id) {
        this.disableId = id;
        this.termination = true;
        this.remark = '';
      },
      async detailClick(id) {
        this.detailDialogVisible = true;
        const res = await highwaySupplierDetail({ id: id });
        if (res.status !== 0) return this.$message.error(res.message);
        const nameArr = res.data.leader.split(',');
        const tellArr = res.data.leaderPhone.split(',');
        const positionArr = res.data.leaderPosition.split(',');
        const personArr = [];
        for (let i = 0; i < nameArr.length; i++) {
          personArr.push({
            name: nameArr[i],
            tell: tellArr[i],
            position: positionArr[i],
          });
        }
        this.detailData = {
          ...res.data,
          person: personArr,
        };
        this.detailData.attachData = res.data.attachmentList.map(item => {
          return {
            name: item.attachmentName,
            time: item.uploadTime,
            id: item.id,
            url: item.attachmentGroup + '/' + item.attachmentPath,
          };
        });
        this.operationData = res.data.operateRecordList;
      },
      async changeClick2(id) {
        this.baseInfoVisible = true;
        const res = await highwaySupplierDetail({ id });
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = {
          teamName: res.data.name,
          account: res.data.account,
          area: res.data.serviceRegionName,
          address: res.data.address,
        };
        this.baseInfo = {
          keyword: res.data.keyword,
          mail: res.data.mailBox,
          tell: res.data.phone,
          id,
        };
      },
      changeClick() {
        this.teamData = {
          teamName: '车队1',
          keyword: 'sadad',
          account: '1770000000',
          area: '重庆市-渝北区',
          address: '重庆市渝北区xxxxxxxxx',
          carTell: '17700000000',
          mail: '',
          name: '张胜男',
          tell: '1833321115321',
          remark: '',
          person: [
            {
              name: '周世鹏',
              tell: '12345512312',
              position: 'lallalal',
            },
            {
              name: '李老八',
              tell: '12312441235',
              position: 'lallalal',
            },
          ],
        };
        this.dialogTitle = '修改公路供应商';
        this.dialogVisible = true;
      },
      searchBtn() {
        this.page = 1;
        this._highwaySupplierList();
      },
      resetBtn() {
        this.teamNameIpt = '';
        this.accountIpt = '';
        this.serviceArea = '';
        this.stateIpt = '';
      },
      addBtn() {
        this.dialogTitle = '新增公路供应商';
        this.edit = 'add';
        this.teamData = {
          teamName: '',
          keyword: '',
          account: '',
          area: '',
          address: '',
          carTell: '',
          mail: '',
          name: '',
          tell: '',
          remark: '',
          referred: '',
          logisticsAttribute: 0,
          person: [
            {
              name: '',
              tell: '',
              position: '',
            },
          ],
          enclosure: [],
        };
        this.dialogVisible = true;
      },
      async editBtn(id, type) {
        const res = await highwaySupplierDetail({ id: id });
        if (res.status !== 0) return this.$message.error(res.message);
        let data = res.data;
        this.dialogTitle = '修改公路供应商';
        if (type == 1) {
          this.edit = 'edit';
        }
        if (type == 2) {
          this.edit = 'change';
        }


        // 对接人信息拼接
        let name = data.leader.split(',');
        let phone = data.leaderPhone.split(',');
        let position = data.leaderPosition.split(',');

        // 服务区域数据
        let area = [];
        let arr = data.serviceRegionId ? data.serviceRegionId.split(';') : [];
        if (arr.length > 0) {
          arr.forEach(function(item) {
            area.push(item.split(','));
          });
        }

        this.teamData = {
          id: data.id,
          teamName: data.name,
          keyword: data.keyword,
          account: data.account,
          // area: data.serviceRegionId.split(','),
          area: area,
          areaName: data.serviceRegionName,
          address: data.address,
          carTell: data.phone,
          mail: data.mailBox,
          adcode: data.regionId,
          longitude: data.longitude,
          latitude: data.latitude,
          regionName: data.regionName,
          name: '',
          tell: '',
          remark: '',
          mark: data.explains,
          referred: data.shortName,
          logisticsAttribute:data.logisticsAttribute,
          person: [],
          enclosure: [],
        };
        if (name.length > 0) {
          for (let i = 0; i < name.length; i++) {
            this.teamData.person.push({
              'name': name[i],
              'tell': phone[i],
              'position': position[i],
            });
          }
        }
        if (data.attachmentList && data.attachmentList.length > 0) {
          for (let i = 0; i < data.attachmentList.length; i++) {
            this.teamData.enclosure.push({
              'name': data.attachmentList[i].attachmentName,
              'id': data.attachmentList[i].id,
            });
          }
        }
        this.dialogVisible = true;
      },
      tableRowClassName({ row }) {
        if (row.status === 7) {
          return 'ui-warning-row';
        } else {
          return '';
        }
      },
      async addClick(type) {
        this.teamData = removeSpace(this.teamData, 'mark');
        // 获取服务区域名称
        let serveObj = this.$refs['checkServe'].getCheckedNodes();
        let str = [];
        if (serveObj.length > 0) {
          serveObj.forEach((item, index) => {
            str.push(item.label.replace(/\s*/g, ''));
          });
        }
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            // 附件
            // if ( this.teamData.enclosure.length===0) return this.$message.warning('至少上传一个附件！！')
            let fileStr = '';
            this.teamData.enclosure.forEach(item => {
              fileStr += item.response ? item.response.data.id + ',' : item.id + ',';
            });
            fileStr = fileStr[fileStr.length - 1] === ',' ? fileStr.slice(0, fileStr.length - 1) : fileStr;
            // 服务区域
            if (this.teamData.area.length === 0) return this.$message.warning('至少选择一个服务区域！！');
            let tempList = [];
            this.teamData.area.forEach(function(item) {
              tempList.push(item.join(','));
            });

            // 对接人信息
            let nameStr = '';
            let tellStr = '';
            let positionStr = '';
            this.teamData.person.forEach(item => {
              nameStr += item.name + ',';
              tellStr += item.tell + ',';
              positionStr += item.position + ',';
            });
            nameStr = nameStr.slice(0, nameStr.length - 1);
            tellStr = tellStr.slice(0, tellStr.length - 1);
            positionStr = positionStr.slice(0, positionStr.length - 1);
            this.imgIsUpload = true;
            const obj = {
              id: this.teamData.id,
              password: this.teamData.password || '',
              name: this.teamData.teamName,
              shortName: this.teamData.referred,
              keyword: this.teamData.keyword,
              account: this.teamData.account,
              // serviceRegionId:areaIdStr,
              serviceRegionId: tempList.join(';'),
              serviceRegionName: str.length > 1 ? str.join(',') : str[0],
              regionId: this.teamData.adcode,
              // regionName:this.teamData.area2,
              address: this.teamData.address,
              longitude: this.teamData.longitude,
              latitude: this.teamData.latitude,
              phone: this.teamData.carTell,
              mailBox: this.teamData.mail,
              explains: this.teamData.mark,
              regionName: this.teamData.regionName,
              leader: nameStr,
              leaderPhone: tellStr,
              leaderPosition: positionStr,
              attachmentIdStr: fileStr,
              logisticsAttribute:this.teamData.logisticsAttribute
            };
            let res;
            if (type == 1) {
              console.log('新增', obj);
              res = await addHighwaySupplier(obj);
            } else if (type == 2) {
              console.log('修改', obj);
              res = await editHighwaySupplier(obj);
            } else {
              console.log('变更', obj);
              res = await changeHighwaySupplier(obj);

            }
            this.imgIsUpload = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            await this._highwaySupplierList();
          } else {
            return false;
          }
        });
      },
      // 终止合作确认按钮
      async terminationClick() {
        this.remark = this.remark.trim();
        if (this.remark == '') {
          this.$message.warning('终止原因不能为空！');
          return false;
        }
        console.log({
          ids: this.disableId,
          examine: this.remark,
          id: 2,
        });
        const res = await highwaySupplierDisable({
          id: this.disableId,
          examine: this.remark,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.termination = false;
        await this._highwaySupplierList();

      },
      // 取消审核
      enableClick(id) {
        this.$confirm('确定要取消审核吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await highwaySupplierEnable({ id: id });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._highwaySupplierList();
          })
          .catch(() => {
            console.log('取消');
          });
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确定要删除该条数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await highwaySupplierDelete({ id: id });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._highwaySupplierList();
          })
          .catch(() => {
            console.log('取消删除');
          });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      levelMinus() {
        this.teamData.person.pop();
      },
      levelAdd() {
        this.teamData.person.push({
          name: '',
          tell: '',
          position: '',
        });
      },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg', 'application/pdf', 'text/plain', 'application/x-zip-compressed', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传附件格式不符合规范！');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        this.imgIsUpload = true;
        return isJPG && isLt10M;
        // return isLt10M
      },
      progress() {
        this.imgIsUpload = true;
      },
      success(res) {
        this.imgIsUpload = false;
        if (res.status !== 0) this.$message.error(res.message);
        this.$message.success(res.message);
        this.imgIsUpload = false;
      },
      uploadChange(file, fileList) {
        if (this.uploadFlag) {
          this.teamData.enclosure.splice(this.uploadIndex, 1, file);
          this.uploadFlag = false;
        } else {
          this.teamData.enclosure = fileList;
        }
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status !== 0) {
            this.teamData.enclosure.splice(this.teamData.enclosure.indexOf(file), 1);
          }
        }
      },
      handleRemove(item, index) {
        this.teamData.enclosure.splice(index, 1);
      },
      imgClick(val, name, id) {
        const arr = ['.jpeg', '.png', '.jpg', '.JPG', '.gif', '.PNG'];
        let str = name.substring(name.indexOf('.'));
        if (arr.indexOf(str) === -1) {
          let token = getSessionStore('token');
          window.location.href = baseUrl + '/web/attachment/download?access_token=' +
            token + '&attachmentId=' + id;
          return;
        }
        this.dialogImageUrl = this.baseImgUrl + val;
        this.imgDialogVisible = true;
      },
      handlePictureCardPreview(file) {
        // this.dialogImageUrl = file.url;
        // this.dialogVisible = true;
        let token = getSessionStore('token');
        this.dialogImageUrl = baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (file.id || file.response.data.id) + '&access_token=' + token;
        console.log(this.dialogImageUrl);
        this.imgDialogVisible = true;
      },
      downloadClick(id) {
        if (id) {
          let token = getSessionStore('token');
          window.location.href = baseUrl + '/web/attachmentFtp/download?attachmentId=' + id + '&access_token=' +
            token;
        } else {
          this.$message.warning('下载失败');
        }
      },
      //外部上传方法，替换
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();

      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    background-color: #fff;

    .upload {
      font-size: 17px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      i {
        margin-right: 10px;
      }

      i:hover {
        color: #00e1ff;
      }
    }

    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .cooperation {
      width: 100%;
      margin: 10px 20px;

      p {
        font-size: 14px;
        color: #606266;
        font-weight: 700;
        margin-bottom: 10px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 20px;
      }
    }

    .detail {
      width: 100%;
      padding: 10px 20px 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }

      .baseInfoContainer {
        padding: 20px
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        .attachment {
          display: flex;
          flex-direction: column;
          padding-top: 10px;

          &Item {
            width: 80%;
            margin-bottom: 10px;
            margin-left: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
              color: #969696;
              font-size: 14px;
            }
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      .specialSelect {
        ::v-deep {
          .el-input__inner {
            // border: none;
          }
        }
      }

      .imgUp {
        .upload-demo {
          display: flex;
        }

        .upload {
          font-size: 17px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          i {
            margin-right: 10px;
          }

          i:hover {
            color: #00e1ff;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        //.el-input__inner{
        //  border: none;
        //}
        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 12px;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-table .ui-warning-row {
      background-color: #fef0f0 !important;
    }

    .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
      background-color: #fef0f0 !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .operate-button {
    margin: 5px;
  }
</style>
<style scoped>
  .add-edit >>> .cont .popupCont {
    max-height: 70vh !important;
    border-bottom: 20px solid #fff;
  }

  .add-edit >>> .cont .popupCont .company {
    max-height: 90% !important;
  }
</style>
